import { render, staticRenderFns } from "./TermsAndConditions2.vue?vue&type=template&id=38031cd6&scoped=true"
import script from "./TermsAndConditions2.vue?vue&type=script&lang=js"
export * from "./TermsAndConditions2.vue?vue&type=script&lang=js"
import style0 from "./TermsAndConditions2.vue?vue&type=style&index=0&id=38031cd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38031cd6",
  null
  
)

export default component.exports